import * as React from 'react';
import Page from '../../components/Page';
import Loader from '../../components/Loader';
import { ErrorFlash } from '../../components/Flash';
import { ProfileContext, ProfileManager } from '../../profile';
import { useRequest, getHeaders } from '../../api/client';
import OrderList from '../../components/OrderList';

const orders = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/store/orders',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export default function Orders() {
  const context = React.useContext(ProfileContext);
  const state = orders(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page title="Orders" subtitle="See all recently placed orders">
      {state.error && <ErrorFlash error={state.error} />}
      <OrderList items={state.data || []} />
    </Page>
  );
}
